import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { CertificationOptionResource } from './CertificationOption';

/**
 * Relationship classes
 */
export class CertificationAttributes {
  title: string = null;
  document: string = null;
  certificationOptionId: number = null;
}

export class CertificationBelongsTo {
  certificationOption: () => CertificationOptionResource = () => new CertificationOptionResource();
}

export class CertificationHasOne {}
export class CertificationHasMany {}

/**
 * Utility interfaces
 */
export interface CertificationMethods {}

export interface CertificationInterface
  extends CertificationAttributes,
    CertificationBelongsTo,
    CertificationType {}

type CertificationType = GConstructor<CertificationInterface>;

export interface CertificationResource
  extends Base<CertificationAttributes>,
    CertificationInterface,
    CertificationMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<CertificationAttributes>({
    queryName: 'user_profile/certifications',
    className: 'Certification',
    AttributesClass: CertificationAttributes,
    BelongsToClasses: [
      {
        Klass: CertificationBelongsTo,
      },
    ],
  });

export const CertificationResourceClass = <TBase extends CertificationType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements CertificationMethods {};

export class CertificationResource extends ClassExtender<CertificationInterface>(
  BaseClass,
  CertificationResourceClass,
) {}

/**
 * Resource instance
 */
export const Certification =
  APILibrary.createResource<CertificationResource>(CertificationResource);
